import { Switch } from '@headlessui/react'

interface ToggleProps {
  value: boolean
  onChange: (newValue: boolean) => void
  disabled?: boolean
}

export const Toggle: React.FC<ToggleProps> = ({
  value,
  onChange,
  disabled
}) => {
  const handleChange = (newValue: boolean) => {
    onChange(newValue)
  }

  return (
    <Switch
      checked={value}
      onChange={handleChange}
      disabled={disabled}
      className={`group relative items-center inline-flex h-4 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${value ? 'bg-lime-100' : 'bg-gray-100'
        }
${disabled ? "cursor-auto" : "cursor-pointer"}`}
    >
      <span
        aria-hidden="true"
        className={`flex items-center justify-center pointer-events-none h-6 w-6 transform rounded-full shadow ring-0 transition duration-200 ease-in-out ${value
            ? `translate-x-5 ${disabled ? 'bg-lime-300' : 'bg-lime-500'}`
            : `translate-x-0 ${disabled ? 'bg-gray-400' : 'bg-gray-600'}`
          }`}
      >
        {value && (
          <svg
            className="h-3 w-3 text-white"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M3 8L6 11L11 3.5"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
    </Switch>
  )
}
